import React from "react";
import InstructorCourseEditor from "./courseEditor";

const InstructorCreateCourse: React.FC = () => {
  return <InstructorCourseEditor />;
};

export default InstructorCreateCourse;
